<h3>Arithmetic operators</h3>

<table class="docTable">
  <thead>
  <tr class="docTableRow">
    <th class="docTableHeader" style="width: 35%">Name</th>
    <th class="docTableHeader" style="width: 65%">Description</th>
  </tr>
  </thead>
  <tbody>
  <tr class="docTableRow">
    <td><code>-</code></td>
    <td>The prefix minus operator, like in &quot;-2&quot;</td>
  </tr>
  <tr class="docTableRow">
    <td><code>+</code></td>
    <td>The prefix minus operator, like in &quot;+2&quot;</td>
  </tr>
  <tr class="docTableRow">
    <td><code>-</code></td>
    <td>The infix minus operator, like in &quot;5-2&quot;</td>
  </tr>
  <tr class="docTableRow">
    <td><code>+</code></td>
    <td>The infix plus operator, like in &quot;5+2&quot;</td>
  </tr>
  <tr class="docTableRow">
    <td><code>*</code></td>
    <td>The multiplication operator</td>
  </tr>
  <tr class="docTableRow">
    <td><code>/</code></td>
    <td>The division operator</td>
  </tr>
  <tr class="docTableRow">
    <td><code>^</code></td>
    <td>The power-of operator</td>
  </tr>
  <tr class="docTableRow">
    <td><code>%</code></td>
    <td>The modulo operator (remainder)</td>
  </tr>
  </tbody>
</table>
<h3>Boolean operators</h3>
<table class="docTable">
  <thead>
  <tr class="docTableRow">
    <th class="docTableHeader" style="width: 35%">Name</th>
    <th class="docTableHeader" style="width: 65%">Description</th>
  </tr>
  </thead>
  <tbody>
  <tr class="docTableRow">
    <td><code>=, ==</code></td>
    <td>The equals operator</td>
  </tr>
  <tr class="docTableRow">
    <td><code>!=,</code></td>
    <td>The not equals operator</td>
  </tr>
  <tr class="docTableRow">
    <td><code>!</code></td>
    <td>The prefix not operator, like in !a</td>
  </tr>
  <tr class="docTableRow">
    <td><code>&gt;</code></td>
    <td>The greater than operator</td>
  </tr>
  <tr class="docTableRow">
    <td><code>&gt;=</code></td>
    <td>The greater equals operator</td>
  </tr>
  <tr class="docTableRow">
    <td><code>&lt;</code></td>
    <td>The less than operator</td>
  </tr>
  <tr class="docTableRow">
    <td><code>&lt;=</code></td>
    <td>The less equals operator</td>
  </tr>
  <tr class="docTableRow">
    <td><code>&amp;&amp;</code></td>
    <td>The and operator</td>
  </tr>
  <tr class="docTableRow">
    <td><code>&#124;&#124;</code></td>
    <td>The or operator</td>
  </tr>
  </tbody>
</table>

<h3>Basic Functions</h3>
<table class="docTable">
  <thead>
  <tr class="docTableRow">
    <th class="docTableHeader" style="width: 35%">Name</th>
    <th class="docTableHeader" style="width: 65%">Description</th>
  </tr>
  </thead>
  <tbody>
  <tr class="docTableRow">
    <td><code>ABS(value)</code></td>
    <td>Absolute (non-negative) value</td>
  </tr>
  <tr class="docTableRow">
    <td><code>AVERAGE(value, ...)</code></td>
    <td>Returns the average (arithmetic mean) of all parameters. If a parameter is of type <em>ARRAY</em>, the average
      of all elements is calculated.
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>CEILING(value)</code></td>
    <td>Rounds the given value an integer using the rounding mode CEILING</td>
  </tr>
  <tr class="docTableRow">
    <td><code>COALESCE(value, ...)</code></td>
    <td>Returns the first non-null parameter, or NULL if all parameters are null</td>
  </tr>
  <tr class="docTableRow">
    <td><code>FACT(base)</code></td>
    <td>Calculates the factorial of a base value</td>
  </tr>
  <tr class="docTableRow">
    <td><code>FLOOR(value)</code></td>
    <td>Rounds the given value an integer using the rounding mode FLOOR</td>
  </tr>
  <tr class="docTableRow">
    <td><code>IF(condition, resultIfTrue, resultIfFalse)</code></td>
    <td>Conditional evaluation function. If <em>condition</em> is true, the <em>resultIfTrue</em> is returned, else the
      <em>resultIfFalse</em> value
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>LOG(value)</code></td>
    <td>The natural logarithm (base e) of a value</td>
  </tr>
  <tr class="docTableRow">
    <td><code>LOG10(value)</code></td>
    <td>The base 10 logarithm of a value</td>
  </tr>
  <tr class="docTableRow">
    <td><code>MAX(value, ...)</code></td>
    <td>Returns the maximum value of all parameters. If a parameter is of type <em>ARRAY</em>, the maximum of all
      elements is calculated.
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>MIN(value, ...)</code></td>
    <td>Returns the minimum value of all parameters. If a parameter is of type <em>ARRAY</em>, the minimum of all
      elements is calculated.
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>NOT(value)</code></td>
    <td>Boolean negation, implemented as a function (for compatibility)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>RANDOM()</code></td>
    <td>Produces a random value between 0 and 1</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ROUND(value, scale)</code></td>
    <td>Rounds the given value to the specified scale, using the current rounding mode</td>
  </tr>
  <tr class="docTableRow">
    <td><code>SQRT(value)</code></td>
    <td>Square root function. Uses the implementation from <em>The Java Programmers Guide To numerical Computing</em> by
      Ronald Mak, 2002.
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>SUM(value, ...)</code></td>
    <td>Returns the sum of all parameters. If a parameter is of type <em>ARRAY</em>, the sum of all elements is
      calculated.
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>SWITCH(expression, value1, result1, [value2-N, result2-N ...], [default])</code></td>
    <td>Returns the <em>result</em> correponding to the first matching <em>value</em> in the specified
      <em>expression</em> or an optional <em>default</em> value if no match found.
    </td>
  </tr>
  </tbody>
</table>
<h3>String Functions</h3>
<table class="docTable">
  <thead>
  <tr class="docTableRow">
    <th class="docTableHeader" style="width: 35%">Name</th>
    <th class="docTableHeader" style="width: 65%">Description</th>
  </tr>
  </thead>
  <tbody>
  <tr class="docTableRow">
    <td><code>STR_CONTAINS(string, substring)</code></td>
    <td>Returns true if the string contains the substring (case-insensitive)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_ENDS_WITH(string, substring)</code></td>
    <td>Returns true if the string ends with the substring (case-sensitive)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_FORMAT(format [,argument, ...])</code></td>
    <td>Returns a formatted string using the specified format string and arguments, using the configured locale</td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_LEFT(value, n)</code></td>
    <td>Returns the first n characters from the left of the given string</td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_LENGTH(string)</code></td>
    <td>Returns the length of the string</td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_LOWER(value)</code></td>
    <td>Converts the given value to lower case</td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_MATCHES(string, pattern)</code></td>
    <td>Returns true if the string matches the RegEx pattern</td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_RIGHT(value, n)</code></td>
    <td>Returns the last n characters from the left of the given string</td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_STARTS_WITH(string, substring)</code></td>
    <td>Returns true if the string starts with the substring (case-sensitive)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_SUBSTRING(string, start[, end])</code></td>
    <td>Returns a substring of the given string, starting at the <em>start</em> index and ending at the <em>end</em>
      index (the end of the string if not specified)
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_TRIM(string)</code></td>
    <td>Returns the given string with all leading and trailing space removed.</td>
  </tr>
  <tr class="docTableRow">
    <td><code>STR_UPPER(value)</code></td>
    <td>Converts the given value to upper case</td>
  </tr>
  </tbody>
</table>
<h3>Trigonometric Functions</h3>
<table class="docTable">
  <thead>
  <tr class="docTableRow">
    <th class="docTableHeader" style="width: 35%">Name</th>
    <th class="docTableHeader" style="width: 65%">Description</th>
  </tr>
  </thead>
  <tbody>
  <tr class="docTableRow">
    <td><code>ACOS(value)</code></td>
    <td>Returns the arc-cosine (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ACOSH(value)</code></td>
    <td>Returns the hyperbolic arc-cosine</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ACOSR(value)</code></td>
    <td>Returns the arc-cosine (in radians)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ACOT(value)</code></td>
    <td>Returns the arc-co-tangent (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ACOTH(value)</code></td>
    <td>Returns the hyperbolic arc-co-tangent (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ACOTR(value)</code></td>
    <td>Returns the arc-co-tangent (in radians)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ASIN(value)</code></td>
    <td>Returns the arc-sine (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ASINH(value)</code></td>
    <td>Returns the hyperbolic arc-sine</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ASINR(value)</code></td>
    <td>Returns the arc-sine (in radians)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ATAN2(y, x)</code></td>
    <td>Returns the angle of atan2 (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ATAN2R(y, x)</code></td>
    <td>Returns the angle of atan2 (in radians)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ATAN(value)</code></td>
    <td>Returns the arc-tangent (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ATANH(value)</code></td>
    <td>Returns the hyperbolic arc-tangent</td>
  </tr>
  <tr class="docTableRow">
    <td><code>ATANR(value)</code></td>
    <td>Returns the arc-tangent (in radians)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>COS(value)</code></td>
    <td>Returns the cosine of an angle (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>COSH(value)</code></td>
    <td>Returns the hyperbolic cosine of a value</td>
  </tr>
  <tr class="docTableRow">
    <td><code>COSR(value)</code></td>
    <td>Returns the cosine of an angle (in radians)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>COT(value)</code></td>
    <td>Returns the co-tangent of an angle (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>COTH(value)</code></td>
    <td>Returns the hyperbolic co-tangent of a value</td>
  </tr>
  <tr class="docTableRow">
    <td><code>COTR(value)</code></td>
    <td>Returns the co-tangent of an angle (in radians)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>CSC(value)</code></td>
    <td>Returns the co-secant of an angle (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>CSCH(value)</code></td>
    <td>Returns the hyperbolic co-secant of a value</td>
  </tr>
  <tr class="docTableRow">
    <td><code>CSCR(value)</code></td>
    <td>Returns the co-secant of an angle (in radians)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>DEG(rad)</code></td>
    <td>Converts an angle measured in radians to an approximately equivalent angle measured in degrees</td>
  </tr>
  <tr class="docTableRow">
    <td><code>RAD(degrees)</code></td>
    <td>Converts an angle measured in degrees to an approximately equivalent angle measured in radians</td>
  </tr>
  <tr class="docTableRow">
    <td><code>SEC(value)</code></td>
    <td>Returns the secant of an angle (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>SECH(value)</code></td>
    <td>Returns the hyperbolic secant of an angle</td>
  </tr>
  <tr class="docTableRow">
    <td><code>SECR(value)</code></td>
    <td>Returns the secant of an angle (in radians)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>SIN(value)</code></td>
    <td>Returns the sine of an angle (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>SINH(value)</code></td>
    <td>Returns the hyperbolic sine of a value</td>
  </tr>
  <tr class="docTableRow">
    <td><code>SINR(value)</code></td>
    <td>Returns the sine of an angle (in radians)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>TAN(value)</code></td>
    <td>Returns the tangent of an angle (in degrees)</td>
  </tr>
  <tr class="docTableRow">
    <td><code>TANH(value)</code></td>
    <td>Returns the hyperbolic tangent of a value</td>
  </tr>
  <tr class="docTableRow">
    <td><code>TANR(value)</code></td>
    <td>Returns the tangent of an angle (in radians)</td>
  </tr>
  </tbody>
</table>
<h3>Date Time Functions</h3>
<table class="docTable">
  <thead>
  <tr class="docTableRow">
    <th class="docTableHeader" style="width: 35%">Name</th>
    <th class="docTableHeader" style="width: 65%">Description</th>
  </tr>
  </thead>
  <tbody>
  <tr class="docTableRow">
    <td><code>DT_DATE_NEW(year, month, day [,hour, minute, second, millis, nanos] [,zoneId])</code></td>
    <td>Returns a new DATE_TIME value with the given parameters. An optional time zone (string) can be specified, e.g.
      &quot;Europe/Berlin&quot;, or &quot;GMT+02:00&quot;. If no zone id is specified, the configured zone id is used.
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>DT_DATE_NEW(millis)</code></td>
    <td>Returns a new DATE_TIME from the epoch of 1970-01-01T00:00:00Z in milliseconds.</td>
  </tr>
  <tr class="docTableRow">
    <td><code>DT_DATE_PARSE(value [,zoneId] [,format, ...])</code></td>
    <td>Converts the given string value to a date time value by using the optional time zone and formats. All formats
      are used until the first matching format. Without a format, the configured formats are used. Time zone can be
      NULL, the the configured time zone and locale is used.
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>DT_DATE_FORMAT(value, [,format] [,zoneId])</code></td>
    <td>Formats the given date-time to a string using the given optional format and time zone. Without a format, the
      first configured format is used. The zone id defaults to the configured zone id.
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>DT_DATE_TO_EPOCH(value)</code></td>
    <td>Converts the given value to epoch timestamp in millisecond.</td>
  </tr>
  <tr class="docTableRow">
    <td><code>DT_DURATION_NEW(days [,hours, minutes, seconds, nanos])</code></td>
    <td>Returns a new DURATION value with the given parameters.</td>
  </tr>
  <tr class="docTableRow">
    <td><code>DT_DURATION_PARSE(value)</code></td>
    <td>Converts the given ISO-8601 duration string representation to a duration value. E.g. &quot;P2DT3H4M&quot; parses
      2 days, 3 hours and 4 minutes.
    </td>
  </tr>
  <tr class="docTableRow">
    <td><code>DT_DURATION_FROM_MILLIS(millis)</code></td>
    <td>Returns a new DURATION value with the given milliseconds.</td>
  </tr>
  <tr class="docTableRow">
    <td><code>DT_DURATION_TO_MILLIS(value)</code></td>
    <td>Converts the given duration to a milliseconds value.</td>
  </tr>
  <tr class="docTableRow">
    <td><code>DT_NOW()</code></td>
    <td>Produces a new DATE_TIME that represents the current moment in time.</td>
  </tr>
  <tr class="docTableRow">
    <td><code>DT_TODAY([zoneId])</code></td>
    <td>Produces a new DATE_TIME that represents the current date, at midnight (00:00). An optional time zone (string)
      can be specified, e.g. &quot;America/Sao_Paulo&quot;, or &quot;GMT-03:00&quot;. If no zone id is specified, the
      configured zone id is used.
    </td>
  </tr>
  </tbody>
</table>
